import { Skeleton } from '@/shared/components/ui/skeleton';

/**
 * Loading placeholder for KeyResourcesPanel. Shown while the curated
 * specialty/care-stage resource bundle (`/find-providers/hub-resources`) is
 * still in flight, so the panel never flashes empty mid-load.
 */
export const KeyResourcesPanelSkeleton = () => (
  <div
    data-testid="key-resources-skeleton"
    className="space-y-4 rounded-2xl border border-border-subtle bg-card-base p-5"
    aria-hidden
  >
    <Skeleton className="h-3 w-28" />
    <Skeleton className="h-24 w-full rounded-xl" />
    <div className="space-y-2 border-t border-border-subtle pt-3">
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-5/6" />
    </div>
  </div>
);
